import React from "react";
import {Profile} from "./profile/Profile";
import {QueryClient, QueryClientProvider} from 'react-query';
import {HeaderTabs} from "./common/HeaderTabs";
import {getCurrentUser, isMinimalApp} from "./CommonFunctions";

const queryClient = new QueryClient();

export const ProfileMain = () => {

    const headerLinks = [
        {label: 'Profil', path: 'profile'},
        {label: 'Organisation', path: 'organization', visible: !isMinimalApp()},
        {label: 'Membres', path: 'members', visible: getCurrentUser().admin},
        {label: 'Connectivité', path: 'connectivity'},
        {label: 'Aide', path: 'help'}
    ];

    return (
        <>
            <HeaderTabs links={headerLinks}/>

            <div id="main-grid__item--main-content" className="main-grid__item">
                <div id="main-content">
                    <QueryClientProvider client={queryClient}>
                        <Profile/>
                    </QueryClientProvider>
                </div>
            </div>
        </>
    )
}


